import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@ciam/library';
import { LocaleService, OptimDecision, OptimService } from '@ciam/library';
import { Observable } from 'rxjs';
import { switchMap, timeout } from 'rxjs/operators';
import { APIResponse } from 'src/app/shared/models/LoginInfoResponse';

export enum PARAMS {
  MOCK = 'mock',
  EMAIL_AS_USERID = 'mockemailasuserid',
  ROLE_AND_STATUS = 'roleandstatus',
  USER_INFO_STATUS = 'userinfostatus',
  RECIPIENTS_STATUS = 'recipientstatus',
  PROFILE_LOCKED = 'profileLocked'
}

const SECRET_QUESTION_CODES: string[] = ['SP2Q1', 'SP2Q2', 'SP2Q3', 'SP2Q4', 'SP2Q5'];

@Injectable({
  providedIn: 'root'
})
export class LoginInfoService {
  request: any;
  private readonly SECRET_QUESTION_ANSWER_RADIX = 36;
  private readonly START_INDEX = 2;
  private readonly END_INDEX = 10;
  constructor(
    private http: HttpClient,
    private config: ConfigurationService,
    private optimService: OptimService,
    private localeService: LocaleService) { }

  // on login screen displays
  getLoginInfo(): Observable<APIResponse> {

    let loginUserInfoUrl = this.config.select<string>('endpoints.user_info.url');

    // refactor [high:5:20230317] do not put test or mocking logic into code that will hit production
    // To differentiate two wire mock API response. It will execute if mock and mockemailasuserid queryParams available on URL
    if (this.getParams(PARAMS.MOCK) === 'true') {
      if (this.getParams(PARAMS.EMAIL_AS_USERID) === 'true') {
        loginUserInfoUrl = `${loginUserInfoUrl}?emailAsUserId=true`;
      } else if (this.getParams(PARAMS.USER_INFO_STATUS)) {
        loginUserInfoUrl = `${loginUserInfoUrl}?${PARAMS.USER_INFO_STATUS}=${this.getParams(PARAMS.USER_INFO_STATUS)}`;
      } else if ((this.getParams(PARAMS.PROFILE_LOCKED) === 'true')) {
        loginUserInfoUrl = `${loginUserInfoUrl}?${PARAMS.PROFILE_LOCKED}=true`;
      }
    }
    return this.http.get(loginUserInfoUrl, { withCredentials: true });
  }

  updateLoginInformation(userParams: any): Observable<APIResponse> {
    let loginUrl: string;
    return this.optimService.decide$('wpro_2fa_on_edit', { country: `${this.localeService.solveLocale().country}` }).pipe(switchMap((result: OptimDecision) => {
      if (result.enabled) {
        loginUrl = this.config.select<string>('endpoints.logininfoV3.url');
        this.request = userParams;
        return this.http.put(loginUrl, this.request, { withCredentials: true });
      }
      else {
        this.request = {
          ...userParams,
          secretQuestionCode: SECRET_QUESTION_CODES[Math.floor(Math.random() * SECRET_QUESTION_CODES.length)],
          secretQuestionAnswer: Math.random().toString(this.SECRET_QUESTION_ANSWER_RADIX).substring(this.START_INDEX, this.END_INDEX) +
            Math.random().toString(this.SECRET_QUESTION_ANSWER_RADIX).substring(this.START_INDEX, this.END_INDEX),
        };
       return this.optimService.decide$('uprc').pipe(switchMap((results: OptimDecision) => {
          if(results.enabled) {
            this.request = userParams;
            loginUrl = this.config.select<string>('endpoints.logininfoUPRC.url');
          } else {
            loginUrl = this.config.select<string>('endpoints.logininfo.url');
          }
          return this.http.put(loginUrl, this.request, { withCredentials: true });
        }));
      }
    }));
  }

  getRoleAndStatus(): Observable<APIResponse> {
    let roleAndStatusUrl = this.config.select<string>('endpoints.roleAndStatus.url');
    // to call wiremock with different scenarios, this block will not execute for the real API calls.
    if (this.getParams(PARAMS.MOCK) === 'true' && this.getParams(PARAMS.ROLE_AND_STATUS)) {
      roleAndStatusUrl += `?roleandstatus=${this.getParams(PARAMS.ROLE_AND_STATUS)}`;
    }
    return this.http.get(roleAndStatusUrl, { withCredentials: true }).pipe(timeout(Number(this.config.select<number>('endpoints.roleAndStatus.timeout'))));
  }
  // on login screen displays
  updateRecipients(): Observable<APIResponse> {
    let recipientsUrl = this.config.select<string>('endpoints.recipients.url');
    if (this.getParams(PARAMS.MOCK) === 'true' && this.getParams(PARAMS.RECIPIENTS_STATUS)) {
      recipientsUrl += `?recipientstatus=${this.getParams(PARAMS.RECIPIENTS_STATUS)}`;
    }
    const request = { recipientProfileProcessDirectiveVO: { skipRecipientNotificationPreferencesRetrieval: true } };
    return this.http.post(recipientsUrl, request, { withCredentials: true }).pipe(
      timeout(Number(this.config.select<number>('endpoints.logininfo.timeout'))));
  }

  getParams(name: any): any {
    const params = new RegExp(`[?&]${name}=([^&#]*)`).exec(window.location.hash);
    if (params) {
      return decodeURI(params[1]) || 0;
    }
    return params;
  }
  getLoginValidateInfo(): Observable<APIResponse> {
    let validateAPI = this.config.select<string>('endpoints.userLogin.url');
    return this.http.get(validateAPI, { withCredentials: true }).pipe(timeout(Number(this.config.select<number>('endpoints.userLogin.timeout'))));
  }
  // //TODO : Separate this method from LoginInfoService
  // updateContactInformation(contactParams): Observable<APIResponse> {
  //   const contactInfoUrl = this.config.config.endpoints.contactInfo.url;
  //   const request = {
  //     ...contactParams,
  //   };
  //   return this.http.put(contactInfoUrl, request, {withCredentials: true}).pipe(
  //     timeout(this.config.config.endpoints.contactInfo.timeout));
  // }

}
